import React, { useContext } from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import esriId from "@arcgis/core/identity/IdentityManager";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// context
import StateContext from "../contexts/StateContext";
import DispatchContext from "../contexts/DispatchContext";

const Header = () => {
    const navigate = useNavigate();
    const GlobalState = useContext(StateContext);
    const GlobalDispatch = useContext(DispatchContext);

    const handleClickForSignOut = () => {
        esriId.destroyCredentials();
        // window.location.reload();
        localStorage.setItem('ifAttemptSignIn', false); // set the value to false in local storage
        sessionStorage.clear(); // clear session storage
        GlobalDispatch({type: "userLogout"});
        navigate("/");
    }
    return (
        <Navbar expand="lg" className="bg-body-tertiary" bg="light" data-bs-theme="light">
            <Container>
                <Navbar.Brand href="#home">Haltestellenanalyse</Navbar.Brand>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {GlobalState.ifSignedIn ? <>
                        <div className="p-2"><b>Eingeloggt als: {GlobalState.name} </b><small>({GlobalState.username})</small>
                        </div>
                        <Button id="sign-out" variant="secondary" size="sm" onClick={handleClickForSignOut}>Abmelden
                        </Button>
                    </> : null}
                </div>
            </Container>
        </Navbar>
    );
};

export default Header;
